import { TActions } from '../../../types/actions';
import { SET_LAYOUT_PARAMS } from './actions';
import { ILayoutState } from './types';

const initialState: ILayoutState = {
  isShortForm: false,
};

export function layout(state: ILayoutState, action: TActions): ILayoutState {
  switch (action.type) {
    case SET_LAYOUT_PARAMS:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state || initialState;
  }
}
